import { guardedFetch, authenticatedFetch } from "./utils";
import type { ApiResponse } from "../../types/api";
import API_CONSTANTS from "../constants/api";
import type { AuthData } from "../helpers/auth/auth";

export type AuthResponse = ApiResponse & {
  redirect_url: string;
  state?: string;
};

export type FinishAuthResponse = ApiResponse & {
  jwt: string;
};

export type JWTResponse = ApiResponse & {
  jwt: string;
};

export type AssessTurnstileResponse = ApiResponse & {
  token: string;
  valid_until: string;
  retry_at: string;
};

export async function authAnonymous(data: AuthData): Promise<JWTResponse> {
  const url = `${API_CONSTANTS.authApiBaseUrl}/auth/anonymous`;
  const result = await guardedFetch(url, {
    method: "POST",
    body: JSON.stringify(data)
  });
  return (await result.json()) as JWTResponse;
}

export async function start(channel: string, data: AuthData): Promise<AuthResponse> {
  const url = `${API_CONSTANTS.authApiBaseUrl}/auth/${channel}/start`;
  const result = await guardedFetch(url, {
    method: "POST",
    body: JSON.stringify(data)
  });
  return (await result.json()) as AuthResponse;
}

export async function finishYoutube(token: string): Promise<FinishAuthResponse> {
  const url = `${API_CONSTANTS.authApiBaseUrl}/auth/youtube`;
  const result = await guardedFetch(url, {
    method: "POST",
    body: JSON.stringify({
      token
    })
  });
  return (await result.json()) as FinishAuthResponse;
}

export const assessTurnstile = async (token: string, campaign: string): Promise<AssessTurnstileResponse> => {
  const url = `${API_CONSTANTS.authApiBaseUrl}/assess-turnstile`;

  const result = await authenticatedFetch(url, {
    method: "POST",
    body: JSON.stringify({
      token: token,
      workflow_key: campaign
    })
  // We want the error handling to be dealt with in the auth helper, not the default error handler
  }, undefined, { "Content-Type": "application/json" }, { skipAllErrorHandling: true });
  return (await result.json()) as AssessTurnstileResponse;
};

export const exchangeTemporaryJWT = async (
  fingerprint: string,
  tempJwt: string,
  turnstileToken?: string
): Promise<JWTResponse> => {
  const url = `${API_CONSTANTS.authApiBaseUrl}/auth/temp-jwt`;
  const result = await authenticatedFetch(
    url,
    {
      method: "POST",
      body: JSON.stringify({
        fingerprint,
        fingerprint_description: navigator.userAgent,
        turnstile_token: turnstileToken
      })
    },
    tempJwt
  );
  return (await result.json()) as JWTResponse;
};
